import React from 'react'

const CosmosList = () => (
    <div>
        <h1>Cosmos</h1>
    </div>
)

export default CosmosList